import { compose } from 'shared/utils/function.utils';
import { getOrderDetailReducer } from './get-order-detail';
import { getOrdersReducer } from './get-orders';

export const extraReducers = compose(getOrderDetailReducer, getOrdersReducer);

export { getOrderDetailAction } from './get-order-detail';
export { getOrdersAction } from './get-orders';
